import { render, staticRenderFns } from "./OriginsForm.vue?vue&type=template&id=0189b947&scoped=true&"
import script from "./OriginsForm.vue?vue&type=script&lang=js&"
export * from "./OriginsForm.vue?vue&type=script&lang=js&"
import style0 from "./OriginsForm.vue?vue&type=style&index=0&id=0189b947&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0189b947",
  null
  
)

export default component.exports